<template>
  <div style="padding-bottom: 50px">
    <van-sticky>
      <navbar :title="title" />
    </van-sticky>

    <van-form>
      <h2 class="van-form-title">审核信息</h2>
      <van-field
        v-model="check_status[product.check_status]"
        label="审核情况"
        readonly
      />
      <van-field v-if="product.check_status == 4"
        v-model="product.audit_remark"
        label="拒绝备注"
        readonly
      />
      <h2 class="van-form-title">订单信息</h2>
      <van-field v-model="product.order_code" label="订单编号" readonly />
      <van-field v-model="product.client_name" label="客户名称" readonly />
      <van-field v-model="product.order_name" label="项目名称" readonly />
      <van-field
        v-model="order_type[product.order_type]"
        label="订单类型"
        readonly
      />
      <van-field v-model="product.user_name" label="退货人" readonly />
      <h2 class="van-form-title">商品信息</h2>
      <div class="product-content">
        <div class="product-item" v-for="item in product.data" :key="item.id">
          <div class="title">
            <div>{{ item.product_name }}</div>
            <span class="rig-text">x{{ item.quantity }}</span>
          </div>
          <div class="product-price">
            <span class="price-text">单价：¥{{ item.amount }}</span>
            <span class="rig-text"
              >总价：¥{{ item.quantity * item.amount }}</span
            >
          </div>
        </div>
        <div class="product-item">
          <div class="title">
            <div>其他费用</div>
            <span class="rig-text">x{{ product.other_fee_quantity }}</span>
          </div>
          <div class="product-price">
            <span class="price-text"
              >单价：¥{{ product.other_fee || 0 }}</span
            >
            <span class="rig-text"
              >总价：¥{{
                (product.other_fee_quantity * product.other_fee).toFixed(2)
              }}</span
            >
          </div>
        </div>
      </div>
      <van-field
        input-align="right"
        v-model="product.receivable_amount"
        label="抵扣应收金额"
        :style="{'color':'red'}"
        readonly
      />
      <van-field
        input-align="right"
        v-model="product.recede_amount"
        label="实际退款金额"
        :style="{'color':'red'}"
        readonly
      />
      <h2 class="van-form-title">备注</h2>
      <van-field
        v-model="product.recede_remark"
        rows="3"
        autosize
        type="textarea"
        :readonly="true"
      />
			<div class="schedule" v-if="product.file != null">
				<p>附件列表</p>
				<div class="schedule-body">
					<div class="file-body">
						<div class="file-body-item" v-for="(item, index) in product.file" :key="index">
							<div class="img-body" v-if="isTypeImage(item.file_type)">
								<van-image width="100" height="100" :src="fileUrl + item.file_id"
									@click="imgLook(fileUrl + item.file_id)" />
							</div>
							<div class="img-body" v-else-if="isTypeMp4(item.file_type)"
								@click="lookVideo(fileUrl + item.file_id)">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">{{ item.file_name }}</div>
							</div>
							<div class="img-body" v-else-if="isType(item.file_type)"
								@click="lookfile(fileUrl + item.file_id)">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">{{ item.file_name }}</div>
							</div>
							<div class="img-body" v-else @click="clickFile">
								<i class="file-icon van-icon-description"></i>
								<div class="file-name">
									{{ item.file_name }}.{{ item.file_type }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
    </van-form>
		<van-popup v-model="showPopup" style="width: 100%;height: 80%;" @opened="pdfpanel">
			<div class="m-pdf" >
				<div id="pdf-content"></div>
			</div>
		</van-popup>
    <audit-btn
      v-if="auditBtn"
      @audit="auditcheck"
      v-bind:content="product"
    ></audit-btn>
  </div>
</template>

<script>
import navbar from "@/components/navBar/index";
import auditBtn from "@/components/retBtn/index";
import { post } from "@/api/post";
import { Toast } from "vant";
import global_url from "@/utils/global";
import { isImage, isMp4,istype } from "@/utils/tool";
import { ImagePreview } from "vant";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
  name: "customer",
  components: {
    navbar,
    "audit-btn": auditBtn,
  },
  data() {
    return {
      title: "退货详情",
      check_status: ["董事长审核", "仓库审核", "财务审核", "已通过", "已驳回"],
      order_type: ["渠道批发", "成品制作", "工程安装", "指导安装", "产品借用"],
      popup: {
        select: false,
      },
      form: {
        requestType: "sales_returns_details",
        recede_id: this.$route.query.id,
      },
      product: {},
      auditBtn: false,
			showPopup: false,
      fileUrl: this.findUrl(),
    };
  },
  mounted() {
    this.getDetails();
    if (this.$route.query.p && this.$route.query.p != "false") {
      this.auditBtn = true;
    }
  },
  methods: {
    //获取订单详情
    getDetails() {
      post(this.form)
        .then((res) => {
          this.product = res.obj;
        })
        .catch(() => {
          Toast.fail("数据异常");
        });
    },
    //提交审核
    auditcheck(obj) {
      if (obj.type == 2) {
        obj.type = 4;
      } else {
        obj.type = this.product.check_status;
      }
      let form = {
        requestType: "approver",
        recede_id: this.product.recede_id,
        check_status: obj.type,
        recede_remark: obj.recede_remark,
        recede_amount: obj.recede_amount,
      };
      post(form)
        .then((res) => {
          if (res.code == 200) {
            this.$route.params.listRefresh = true;
            this.$router.go(-1);
            return Toast("审核成功");
          } else {
            return Toast(res.msg);
          }
        })
        .catch((res) => {
          return Toast.fail(res.msg);
        });
    },
		pdfpanel() {
			//先实例化
			this.pdfh5 = new Pdfh5("#pdf-content", {
				pdfurl: this.pdfUrl,
				goto: 1,
				lazy: true,
			});
			this.pdfh5.scrollEnable(true); 
		},
		lookfile(row) {
			this.showPopup = true;
			this.pdfUrl = row
			// console.log(row);

		},
    isTypeMp4(name) {
      return isMp4(name);
    },
    isTypeImage(name) {
      return isImage(name);
    },
		isType(name) {
			return istype(name);
		},
    findUrl() {
      return global_url.fileUrl;
    },
    imgLook(url) {
      ImagePreview({
        images: [url],
      });
    },
    clickFile() {
      return Toast.fail("暂不支持该文件查看");
    },
  },
};
</script>

<style lang="scss" scoped>
.van-form-title {
  margin: 0;
  padding: 20px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.product-content {
  background-color: white;
  padding: 0 1.14286rem;
  .product-item {
    padding: 0.8rem 0;
    border-bottom: 1px solid #eee;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .product-price {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
    }
    .rig-text {
      font-size: 12px;
    }
    .price-text {
      color: #999;
      font-size: 12px;
    }
  }
}
.m-pdf {
	// 保证pdf区域铺满整个屏幕
	// 方法1：使用vw和vh视窗单位，1vw=视窗宽度的1%；1vh=视窗高度的1%
	// width: 100vw;
	// height: 100vh;
	// 方法2：使用fixed定位
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
}

.file-body {
	width: calc(100% + 10px);
	padding: 0;
	display: flex;
	flex-wrap: wrap;

	.file-body-item {
		list-style: none;
		flex: 0 0 calc(33.33% - 10px);
		margin-right: 10px;
	}
}

.schedule {
	margin-top: 1px;
	margin-bottom: 12px;
	// padding-left:15px;
	margin-left: 20px;
	margin-right: 20px;

	// overflow: hidden;
	.file-body {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-top: 2px;

		&-item {
			position: relative;
			margin: 0 2px 2px 0;
			cursor: pointer;

			.img-body {
				display: block;
				width: 80px;
				height: 80px;
				overflow: hidden;
				border-radius: 8px;
				box-shadow: #ebedf0 0 4px 12px;
				text-align: center;

				img {
					object-fit: cover;
					display: block;
					width: 100%;
					height: 100%;
				}

				.file-icon {
					position: relative;
					display: inline-block;
					font: normal normal normal 14px/1 "vant-icon";
					font-size: inherit;
					text-rendering: auto;
					-webkit-font-smoothing: antialiased;
					color: #646566;
					font-size: 20px;
					margin-top: 15px;
				}

				.file-name {
					box-sizing: border-box;
					width: 100%;
					margin-top: 4px;
					padding: 0 4px;
					color: #646566;
					font-size: 12px;
					text-align: center;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
				}
			}
		}
	}
}
</style>